export default "__VITE_ASSET__vAZ68EZ8__"